import { SET_DEVICE_ID } from 'root/src/client/logic/app/actionIds'

export default deviceId => ({
	type: SET_DEVICE_ID,
	payload: deviceId,
})
